export const setHidden = (el, isHidden) => {
	if (!el) return
	el.style.display = isHidden ? 'none' : ''
	isHidden ? el.setAttribute('aria-hidden', 'true') : el.removeAttribute('aria-hidden')
}

export const closestField = (el) => {
	if (!el) return null
	return (
		el.closest('.wc-block-components-text-input') ||
		el.closest('.wc-block-components-combobox') ||
		el.closest('.wc-block-components-select') ||
		el
	)
}

export const getCheckoutRoot = () =>
	document.querySelector('.wp-block-woocommerce-checkout') ||
	document.querySelector('.wc-block-checkout')

export const observeCheckoutEnhancements = (root, enhance) => {
	if (!root) return
	if (root.dataset.polycoteCheckoutEnhanced) return
	root.dataset.polycoteCheckoutEnhanced = '1'

	enhance()

	let t = null
	const observer = new MutationObserver(() => {
		if (t) window.clearTimeout(t)
		t = window.setTimeout(enhance, 75)
	})

	observer.observe(root, { childList: true, subtree: true })
}
